<form [formGroup]="form" class="section__hotel">
  <div class="section__hotel__tags">
    <app-pop-up-pasajero
      #popUp
      [nroAdultos]="2"
      (emitDistributionObject)="distributionObject = $event"
      (emitDistribution)="distribution = $event"
      [onlyPasajeros]="true"
    ></app-pop-up-pasajero>
  </div>
  <div class="section__hotel__inputs">
    <div class="section__hotel__inputs__group">
      <input
        aria-label="State3"
        formControlName="destino"
        (keyup)="autoComplete($event)"
        placeholder="¿Donde le gustaría ir?"
        (keypress)="inputValidator.removeNonValid($event, inputValidator.VALID_NAME)"
      />
      <img src="./assets/svg/location-red.svg" alt="o" />
    </div>
    <app-input-range #childDates [typeFlight]="-1"></app-input-range>
    <app-button (buttonClick)="search()" [isFullWidth]="true" buttonSize="lg">
      <i aria-label="Buscar" class="custom-icon icon-search"></i>
      <span class="ms-2">Buscar</span>
    </app-button>
  </div>
</form>
